// Temporary per-cart caps supplied by AFTH; not shared remaining inventory.
export const temporaryStockLimits = {
  'keychain:capybara': 10, 'keychain:matcha': 20, 'keychain:croissant': 17,
  'sticker:beartea': 23, 'sticker:whale': 31,
  'print:mala': 45, 'print:fish-glossary': 38,
};
// Proposed backend contract: availability[stockKey] is the remaining integer stock.
// Missing values are unknown, never zero. AFTH's opening allocations are not live stock.
export const stockKey = (type, design, size = '') =>
  [type.toLowerCase(), design.toLowerCase().replace(/\s+/g, '-'), ...(type === 'Shirt' ? [size] : [])].join(':');

export const remainingStock = (availability, key) => {
  const value = availability?.[key] ?? temporaryStockLimits[key];
  return Number.isInteger(value) && value >= 0 ? value : null;
};

export const stockLabel = (availability, key) => {
  const remaining = remainingStock(availability, key);
  return remaining === null ? '' : remaining === 0 ? ' — Sold out' : ` — ${remaining} available`;
};

export const makeSelections = (types, options) => types.map((type, index) => ({
  type, design: options[index]?.design || '', size: options[index]?.size || '',
  stockKey: stockKey(type, options[index]?.design || '', options[index]?.size || ''), quantity: 1,
}));

export const stockProblem = (availability, cartItems) => {
  const totals = new Map();
  for (const item of cartItems) {
    for (const selection of item.selections || []) {
      const previous = totals.get(selection.stockKey)?.quantity || 0;
      totals.set(selection.stockKey, { ...selection, quantity: previous + selection.quantity * item.quantity });
    }
  }
  for (const [key, selection] of totals) {
    const remaining = remainingStock(availability, key);
    if (remaining !== null && selection.quantity > remaining) {
      return `${selection.design}${selection.size ? ` (${selection.size})` : ''}: ${remaining === 0 ? 'sold out' : `only ${remaining} available`}. Please adjust your choices or cart quantity.`;
    }
  }
  return '';
};
